import Reveal from "@/components/base/Reveal";

const entries = [
  {
    icon: "ri-flag-2-line",
    title: "大结局解析",
    desc: "大结局讲了什么、主线如何收束",
    href: "#ending",
    tone: "primary",
  },
  {
    icon: "ri-book-open-line",
    title: "剧情介绍",
    desc: "主题、受众与整体故事走向",
    href: "#overview",
    tone: "secondary",
  },
  {
    icon: "ri-list-check-2",
    title: "分集剧情",
    desc: "四个阶段、八段脉络逐条展开",
    href: "#episodes",
    tone: "accent",
  },
  {
    icon: "ri-user-search-line",
    title: "人物线索",
    desc: "六个关键人物的动机与选择",
    href: "#characters",
    tone: "primary",
  },
];

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50",
  secondary:
    "bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50",
  accent: "bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-foreground-950",
};

export default function QuickNav() {
  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <Reveal>
          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
            <div className="flex flex-col gap-2 border-b border-background-200 pb-5 md:flex-row md:items-center md:justify-between">
              <p className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-filter-3-line text-primary-600" />
                本站快速入口
              </p>
              <p className="text-xs text-foreground-500 md:text-sm">
                不知道从哪看起？先选一个最关心的方向
              </p>
            </div>

            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {entries.map((entry) => (
                <a
                  key={entry.title}
                  href={entry.href}
                  className="group flex items-start gap-4 rounded-lg border border-transparent bg-background-50 p-4 transition hover:border-background-300"
                >
                  <span
                    className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-xl transition ${toneMap[entry.tone]}`}
                  >
                    <i className={entry.icon} />
                  </span>
                  <span>
                    <span className="block font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {entry.title}
                    </span>
                    <span className="mt-1 block text-xs leading-relaxed text-foreground-500">
                      {entry.desc}
                    </span>
                  </span>
                </a>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}